module.exports = __webpack_public_path__ + "images/stock-783e0724d5977c5404b94567e8f66e5b.jpg";